import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { type ActionsObservable, type Epic } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import {
	FETCH_CONNECTED_SPACE,
	updateConnectedSpaceOrPageContent,
	type FetchConnectedSpaceAction,
} from '../actions';
import { type State } from '../types';
import { type Action, type MiddlewareAPI } from 'redux';
import { getConfluenceSpace$ } from './requests';
import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { getProjectId, getProjectType } from '../project/selectors';

const fetchConnectedSpaceEpic: Epic<Action, State> = (action$, store: MiddlewareAPI<State>) =>
	(action$.ofType(FETCH_CONNECTED_SPACE) as ActionsObservable<FetchConnectedSpaceAction>).switchMap<
		FetchConnectedSpaceAction,
		any
	>(({ spaceKey }) => {
		return getConfluenceSpace$(
			spaceKey,
			getProjectId(store.getState()),
			getProjectType(store.getState()),
		)
			.mergeMap(({ id, name, homepage, icon: { path: iconPath }, _links: { base, webui } }) => {
				fetchSuccess('confluence.space');
				return of(
					updateConnectedSpaceOrPageContent({
						spaceId: id,
						title: name,
						isConnectedToPage: false,
						projectSpacePageTitleHasBeenFetched: true,
						url: `${base}${webui}`,
						iconUrl: `${base}${iconPath}`,
						pageId: homepage?.id || null, // setting the id to null will cause root pages to be fetched
					}),
				);
			})
			.catch((err) => {
				fetchFailed('confluence.space', err);
				return of(
					updateConnectedSpaceOrPageContent({
						spaceId: null,
						title: null,
						iconUrl: null,
						projectSpacePageTitleHasBeenFetched: true,
						pageId: null,
					}),
				);
			});
	});

export default fetchConnectedSpaceEpic;
